import { useRef } from "react";
import { useClickAway } from "react-use";
import { Optional } from "../../types";
import { AutocompleteSearchResults } from "./autocomplete-search-results.component";
import { AutocompleteSearch } from "./autocomplete-search.component";
import styles from "./autocomplete.module.css";
import { AutocompleteGroup, AutocompleteItem } from "./autocomplete.types";
import { useAutocomplete } from "./hooks";
import { AutocompleteProvider } from "./providers";
import { type InputSize } from "../../elements";

export type AutocompleteProps = {
  onChange?: Optional<(value?: Optional<AutocompleteItem<any>>) => void>;
  defaultOptions?: Optional<AutocompleteItem[]>;
  variant?: Optional<"default" | "mobile">;
  value?: Optional<AutocompleteItem>;
  onClose?: Optional<() => void>;
  onOpen?: Optional<() => void>;
  options: AutocompleteGroup[];
  isOpen?: Optional<boolean>;
  label: string;
  dataQA?: string;
  dataQaExtra?: string;
  size?: InputSize;
};

function AutocompleteWithContext() {
  const domRef = useRef<HTMLDivElement>(null);
  const { isOpen, close } = useAutocomplete();
  useClickAway(domRef, () => {
    if (isOpen) {
      close();
    }
  });

  return (
    <div ref={domRef} className={styles.Container}>
      <AutocompleteSearch />
      {isOpen && <AutocompleteSearchResults />}
    </div>
  );
}

export function Autocomplete({ ...props }: AutocompleteProps) {
  return (
    <AutocompleteProvider {...props}>
      <AutocompleteWithContext />
    </AutocompleteProvider>
  );
}
